import { StatsIndexDto } from "@domain";
import { AsyncInteractor } from "@kernel/frontend-react-app";
import { StatsRepositoryService } from "../services";

export interface LoadStatsRepositoryService {
  load(room?: string): Promise<StatsIndexDto>;
}

export interface LoadRepositoryInteractorProps {
  room?: string;
}

export class LoadStatsRepositoryInteractor extends AsyncInteractor<
  LoadStatsRepositoryService,
  LoadRepositoryInteractorProps,
  StatsIndexDto
> {
  public async execute(
    props: LoadRepositoryInteractorProps
  ): Promise<StatsIndexDto> {
    return await this.service.load(props.room);
  }

  public static create() {
    const service = new StatsRepositoryService();
    return new LoadStatsRepositoryInteractor(service);
  }
}
